import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { IndustryVisitsRoutingModule } from './industry-visits-routing.module';
import { IndustryVisitsListComponent } from './industry-visits-list/industry-visits-list.component';
import { IndustryVisitsCreateComponent } from './industry-visits-create/industry-visits-create.component';

@NgModule({
  declarations: [IndustryVisitsListComponent, IndustryVisitsCreateComponent],
  imports: [
    CommonModule,
    IndustryVisitsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class IndustryVisitsModule { }
